// ---------------------------------------
// Query Builder JS
// NOTE: two references to SCM.QueryBuilder.configure() will need to placed in client.solrsearch.js (or equivalent file)
// 1) in SolrSearch.ajaxComplete
// 2) in SolrSearch.init
// ----------------------------------------

var SCM = SCM || {};


SCM.QueryBuilder = {};

SCM.QueryBuilder.defaults = {
    runSearch: function (queryString) {
        window.location.hash = '#' + queryString;
    }
};

SCM.QueryBuilder.configure = function () {
    var $queryFilter = $('.querybuilder-filter'),
        $queryFilterCurrentWrap = $('.querybuilder-filter-current-wrap'),
        $queryFilterDropdown = $('.querybuilder-filter-dropdown'),
        $queryInputStandard = $('.querybuilder-input-standard'),
        $queryInputCitation = $('.querybuilder-input-citation'),
        $queryInstance = $('.querybuilder-instance'),
        $queryAdd = $('.querybuilder-add'),
        $queryFilterDropdownLabel = $('.querybuilder-filter-label');


    // if Citation filter was selected, show the appropriate fields
    var testForCitationFields = function (thisElement) {
        var $thisFilter = thisElement,
            $thisInstance = $thisFilter.closest('.querybuilder-instance');

        if ($thisFilter.hasClass('filter-citation')) {
            $thisInstance.find($queryInputStandard).addClass('hide');
            $thisInstance.find($queryInputCitation).removeClass('hide');
        } else {
            $thisInstance.find($queryInputCitation).addClass('hide');
            $thisInstance.find($queryInputStandard).removeClass('hide');
        }
    };


    // called when query input is altered or a plus button is clicked
    var testQueryInput = function (thisElement) {

        var $thisInstance = thisElement;

        // is this a citation input or a querybuilder input?
        if ($thisInstance.hasClass('citation-input')) {
            // Citation Filter
            var $citeYear = $thisInstance.find('.citation-year').val().replace(/\'/g, '').trim().length,
                $citeVol = $thisInstance.find('.citation-volume').val().replace(/\'/g, '').trim().length,
                $citeIssue = $thisInstance.find('.citation-issue').val().replace(/\'/g, '').trim().length,
                $citePage = $thisInstance.find('.citation-page').val().replace(/\'/g, '').trim().length;

            if ($citeYear > 0 || $citeVol > 0 || $citeIssue > 0 || $citePage > 0) {
                return true;
            } else if ($citeYear === 0 && $citeVol === 0 && $citeIssue === 0 && $citePage === 0) {
                return false;
            }

        } else {
            // Normal Filter
            var $inputSize = $thisInstance.val().replace(/\'/g, '').trim().length;

            if ($inputSize === 0) {
                return false;
            } else if ($inputSize > 0) {
                return true;
            }
        }
    };


    // (de-)activate Add Term button if it passes testQueryInput()
    var enableDisableAddButton = function (testThisInstance) {
        testQueryInput(testThisInstance)
            ? $queryAdd.addClass('valid').prop('disabled', false)
            : $queryAdd.removeClass('valid').prop('disabled', true);
    };


    // page load actions placed in anonymous function
    (function ($) {

        // count the number of instances on page load
        var $visibleInstances = 0;
        $('.querybuilder-instance').each(function () {
            if (!$(this).hasClass('hide')) {
                $visibleInstances++;
            }
        });

        // get selected filters for each visible instance when page loads
        $queryFilter.each(function () {
            var $this = $(this);
            if ($this.hasClass('selected')) {
                $this.closest($queryFilterCurrentWrap).find('.querybuilder-filter-label-text').text($this.text());
                testForCitationFields($this);
            }
        });

        if (!SCM.QueryBuilder._docHandlersAttached) {
            const observer = new MutationObserver(() => {
                $('.ui-datepicker-prev, .ui-datepicker-next').attr('href', '#');
                $('.ui-datepicker-prev').attr('aria-label', 'Previous');
                $('.ui-datepicker-next').attr('aria-label', 'Next');
            });
            observer.observe(document.body, { childList: true, subtree: true });

            $(document).on('click.scm-querybuilder', '.ui-datepicker-prev, .ui-datepicker-next', function (event) {
                event.preventDefault();
            });

            SCM.QueryBuilder._docHandlersAttached = true;
        }


    })(jQuery);


    // Opens or closes the filter dropdown, scoping focus to the first item inside it.
    // Keeps aria-hidden and aria-expanded in sync with visibility.
    $queryFilterCurrentWrap.off('click');
    $queryFilterCurrentWrap.on('click', function (e) {
        $('.sort-order-list').addClass('hide'); // hide other dropdown on page (assume it's open)

        e.stopPropagation();

        var $thisChild = $(this).find($queryFilterDropdown);
        var $dropdownButton = $(this).find($queryFilterDropdownLabel);

        // auto hide filter dropdowns OTHER than this one
        $queryFilterDropdown.not($thisChild).addClass('hide').attr('aria-hidden', 'true');
        // Reset aria-expanded on the other buttons (prevents a stale "expanded" announcement
        // when switching directly from one dropdown to another without closing first)
        $queryFilterCurrentWrap.not($(this)).find($queryFilterDropdownLabel).attr('aria-expanded', 'false');

        if ($thisChild.hasClass('hide')) {
            $thisChild.removeClass('hide');
            $thisChild.attr('aria-hidden', 'false');
            $dropdownButton.attr('aria-expanded', 'true');
            $thisChild.find('.querybuilder-filter').first().focus();
        } else {
            $thisChild.addClass('hide');
            $thisChild.attr('aria-hidden', 'true');
            $dropdownButton.attr('aria-expanded', 'false');
        }
    });

    // Keyboard navigation scoped to the current dropdown instance
    $queryFilter.on('keydown', function (e) {
        var $currentDropdown = $(this).closest('.querybuilder-filter-dropdown');
        var $scopedItems = $currentDropdown.find('.querybuilder-filter');
        var currentIndex = $scopedItems.index(this);

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            $scopedItems.eq((currentIndex + 1) % $scopedItems.length).focus();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            $scopedItems.eq((currentIndex - 1 + $scopedItems.length) % $scopedItems.length).focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).click(); // Delegates to the existing click handler (pattern: SCM.SearchAccessibility.js)
        } else if (e.key === 'Escape') {
            e.preventDefault();
            // Find the specific button that belongs to this dropdown
            var $currentWrap = $(this).closest($queryFilterCurrentWrap);
            var $dropdown = $currentWrap.find($queryFilterDropdown);
            var $dropdownButton = $currentWrap.find($queryFilterDropdownLabel);

            $dropdown.addClass('hide');
            $dropdown.attr('aria-hidden', 'true');
            $dropdownButton.attr('aria-expanded', 'false');
            $dropdownButton.focus(); // Return focus to the correct button
        }
    });

    // Closes all open filter dropdowns when clicking anywhere on the search results page.
    // Works because the wrapper handler calls stopPropagation, so clicks inside
    // the dropdown never reach this handler.
    $(document).off('click', '.pg_searchresults');
    $(document).on('click', '.pg_searchresults' ,function () {
        $queryFilterDropdown.addClass('hide');
        $queryFilterDropdown.attr('aria-hidden', 'true');
        $queryFilterDropdownLabel.attr('aria-expanded', 'false');
    });

    // Selects a filter option, closes the dropdown, and returns focus to the trigger button.
    // stopPropagation prevents the click from bubbling to the wrapper, which would
    // toggle the dropdown back open.
    $queryFilter.off('click');
    $queryFilter.on('click', function (e) {
        e.stopPropagation();

        var $thisFilter = $(this),
            $thisFilterList = $thisFilter.closest('.querybuilder-filter-dropdown');
        $thisLabel = $thisFilter.closest($queryFilterCurrentWrap).find('.querybuilder-filter-label-text');

        $thisFilterList.children($thisFilter).removeClass('selected'); // remove '.selected' from all filters before ...
        $thisFilter.addClass('selected'); // assigning it to this filter

        $thisLabel.text($thisFilter.text()); // set current filter label to selected
        testForCitationFields($thisFilter);

        // Close dropdown and return focus to the trigger button (pattern: SCM.Modals.js focus restore)
        var $currentWrap = $thisFilter.closest($queryFilterCurrentWrap);
        var $dropdown = $currentWrap.find($queryFilterDropdown);
        var $dropdownButton = $currentWrap.find($queryFilterDropdownLabel);
        $dropdown.addClass('hide');
        $dropdown.attr('aria-hidden', 'true');
        $dropdownButton.attr('aria-expanded', 'false');
        $dropdownButton.focus();

        var curOptionIsCitation = $thisFilter.hasClass('filter-citation');
        if (curOptionIsCitation) {
            var curCitationInstanceId = $thisFilter.closest('.querybuilder-instance').attr('id)');
            //hide Citation in rest of the instances
            showCitationOptionForOtherInstances(curCitationInstanceId, false);
        } else {
            checkForCitation();
        }
    });


    // when user changes value of an input
    $('.js-querybuilder-input, .citation-input').on('keyup', function () {
        $('#queryBuilderSubmit').addClass('btn-green').removeAttr('style'); // something changed, notify user that they need to update
        //testQueryInput($(this)) ? $queryAdd.addClass('valid').removeAttr('disabled') : $queryAdd.removeClass('valid').attr('disabled');
        enableDisableAddButton($(this));
    });


    // reveal new instance of Query Builder when plus is clicked
    $queryAdd.off('click');
    $queryAdd.on('click', function () {

        // is the Add Term button currently disabled? Show a message
        if ($(this).prop('disabled')) {
            alert('A value must be entered before adding another filter.'); // this will eventually be a modal
        } else {
            // show next instance of QueryBuilder
            var $currentInstanceNum = 0,
                $nextInstanceNum = 1;

            // find last active QB instance (one without a class of 'hide')
            $queryInstance.each(function () {
                if (!$(this).hasClass('hide')) {
                    $currentInstanceNum++;
                    $nextInstanceNum++;
                }
            });

            var $nextInstanceID = $('#qbInstance' + $nextInstanceNum);

            // show next QB instance & disable button
            $nextInstanceID.removeClass('hide');
            $queryAdd.removeClass('valid').prop('disabled', true);
        }

    });

    $('.querybuilder-submit').off('click');
    $('.querybuilder-submit').on('click', function () {
        var $isNbnjTocHf = $('#hfNbnjToc');
        if ($isNbnjTocHf.length && !$isNbnjTocHf.val()) {
            $(this).removeClass('btn-green').attr('style', 'opacity: 0.3;');
        }
    });


    //*Restrict Citation to only one*
    //returns the queryBuilder instanceId of the instance if citation is selected
    //returns null if no instance has Citation
    function isCitationyOptionAlreadySpecified() {
        var citeInstanceId = null;
        $queryInstance.each(function () {
            if (!$(this).hasClass('hide')) {
                var citeVisible = !$(this).find($queryInputCitation).hasClass('hide');
                if (citeVisible) {
                    citeInstanceId = $(this).attr('id');
                    return false;
                }
            }
        });
        return citeInstanceId;
    }


    //---
    //Shows or hides the citation option in the dropdow of all instances except for the one that is passed in.
    //if curCiteInstanceId is null, shows/hides citation in all instances
    //---
    function showCitationOptionForOtherInstances(curCiteInstanceId, show) {
        $queryInstance.each(function () {
            var instanceId = $queryInstance.attr('id');
            var $citeOption = $(this).find('li[data-fieldname="Citation"]');

            //curCiteInstanceId=null means no instance currently has Citation.
            if (instanceId !== curCiteInstanceId || curCiteInstanceId === null) {
                show ? $citeOption.show() : $citeOption.hide();
            }
        });
    }


    //---
    //Checks if Citation is selected
    //---
    function checkForCitation() {
        var citeInstanceId = isCitationyOptionAlreadySpecified();
        if (citeInstanceId !== null) {
            //citation Option selected
            showCitationOptionForOtherInstances(citeInstanceId, false);
        } else {
            //citation Option not selected
            showCitationOptionForOtherInstances(citeInstanceId, true);
        }
    }
};

$('.js-main').off('click', '.querybuilder-submit');
$('.js-main').on('click', '.querybuilder-submit', function () {	

    var redirectUrl = '';
    var currentSearchTerm = $('#hfCurrentSearchTerm').val();    //Existing Search Term
    var currentDataUrl = $('.querybuilder-submit').attr('data-current-url');
    var qbObject = new Object();
    var instanceIndex = 1;
    var qbObjectInitialized = false;

    //Updates the DataUrl for the All option
    function updateDataUrlForAllOption(searchTerm, currentDataUrl) {
        var newQueryTerm = '';
        var updatedUrl = '';

        if (currentDataUrl.indexOf('q=') >= 0) {
            var queryTerm = SCM.Common.getQueryStringValue(currentDataUrl, 'q');

            newQueryTerm = newQueryTerm + queryTerm + ' AND ' + searchTerm;
            updatedUrl = currentDataUrl.replace(queryTerm, newQueryTerm);
        }
        else {
            //"q" parm does not exist in currentDataUrl
            updatedUrl = 'q=' + searchTerm + '&' + currentDataUrl;
        }
        return updatedUrl;
    }


    //loop through all instances
    $('.querybuilder-wrap .querybuilder-instance').each(function (i) {

        //process only the instances which are visible
        var instanceVisible = !$(this).hasClass('hide');
        if (instanceVisible) {
            //get the text and value for the dropdown item
            var qbSearchTypeDisplayName = $(this).find('.querybuilder-filter-dropdown li.selected').text();
            var qbSearchTypeFieldName = $(this).find('.querybuilder-filter-dropdown li.selected').attr('data-fieldname');

            //The 1st instance defaults to SearchTerm ("q") w/o any filter with the user having the abiliity to change it to a filter. 
            var filterSpecifiedForSearchTerm = false;
            if (instanceIndex === 1) {
                //check if user converted SearchTerm to a filter.
                if (typeof qbSearchTypeFieldName !== 'undefined' && qbSearchTypeFieldName !== null && $.trim(qbSearchTypeFieldName) !== '') {
                    //remove q parameter because searchTerm needs to be executed against a particular field
                    var qTerm = SCM.Common.getQueryStringValue(currentDataUrl, 'q');
                    if (qTerm !== null && qTerm !== '') {
                        qTerm = 'q=' + qTerm;
                        var qTermIndex = currentDataUrl.indexOf(qTerm);
                        var ampersandIndex = qTermIndex + qTerm.length;
                        qTerm += currentDataUrl[ampersandIndex] === '&' ? '&' : '';
                        currentDataUrl = currentDataUrl.replace(qTerm, '');
                    }

                    filterSpecifiedForSearchTerm = true;
                }
                else {
                    //user didn't change the searchTerm to Filter - Execute this as "q"
                    var searchTerm = $(this).find('.js-querybuilder-input').val().trim();
                    searchTerm = searchTerm.replace('&', encodeURIComponent('&'));
                    if (currentSearchTerm !== searchTerm) {
                        const pairs = currentDataUrl.split('&');

                        let params = getQueryStringSearchParams(pairs);

                        currentDataUrl = getUpdatedDateUrl(params, currentDataUrl, searchTerm);
                    } 

                    //to identify this particular condition, setting this as "q" so Model can process it appropriately.
                    qbObject.q = searchTerm;
                    qbObjectInitialized = true;

                    //skip this iteration and process the next item.
                    instanceIndex++;
                    return true;
                }
            }

            //find the search term (#QueryBuilderSearchTerm - parent Div: querybuilder-input-standard) 
            var qbSearchTerm = '';

            switch (qbSearchTypeDisplayName) {
                case '':
                    //User specified a value for searchTerm but didn't select an option from dropdown.
                    //Same as All (searchTerm will be executed as Q)
                    var keyOptionOrdinal = 'q' + instanceIndex;
                    qbSearchTerm = $(this).find('.js-querybuilder-input').val().trim();
                    qbSearchTerm = qbSearchTerm.replace('&', encodeURIComponent('&'));
                    if (qbSearchTerm !== '') {
                        currentDataUrl = updateDataUrlForAllOption(qbSearchTerm, currentDataUrl);
                        qbObject[keyOptionOrdinal] = qbSearchTerm;
                        qbObjectInitialized = true;
                    }
                    break;
                case 'All':
                    qbSearchTerm = $(this).find('.js-querybuilder-input').val().trim();
                    qbSearchTerm = qbSearchTerm.replace('&', encodeURIComponent('&'));

                    if (qbSearchTerm !== '') {
                        currentDataUrl = updateDataUrlForAllOption(qbSearchTerm, currentDataUrl);

                        //Since there could me multiple "All"s, tagging ordinal to make them unique.
                        var keyName = 'All' + instanceIndex;
                        if (instanceIndex === 1 && filterSpecifiedForSearchTerm || instanceIndex !== 1) {
                            qbObject[keyName] = qbSearchTerm;
                            qbObjectInitialized = true;
                        }
                    }
                    break;
                case 'Citation':
                    var citationObj = new Object();

                    //Since there could me multiple "Citation"s, tagging ordinal to make them unique.
                    var keyCitationName = 'Citation' + instanceIndex;

                    var year = $(this).find('#instance_CitationYear').val().trim();
                    var volume = $(this).find('#instance_CitationVolume').val().trim();
                    var issueNo = $(this).find('#instance_CitationIssueNo').val().trim();
                    var page = $(this).find('#instance_CitationPage').val().trim();

                    if (year !== '' || volume !== '' || issueNo !== '' || page !== '') {
                        //initialize Citation object
                        qbObject[keyCitationName] = citationObj;
                        qbObjectInitialized = true;

                        if (year !== null && year !== '') {
                            citationObj.Year = year;
                        }
                        if (volume !== null && volume !== '') {
                            citationObj.Volume = volume;
                        }
                        if (issueNo !== null && issueNo !== '') {
                            citationObj.IssueNo = issueNo;
                        }
                        if (page !== null && page !== '') {
                            citationObj.StartPage = page;
                        }
                    }
                    break;
                default:
                    var keyDefName = qbSearchTypeFieldName + instanceIndex;
                    qbSearchTerm = $(this).find('.js-querybuilder-input').val().trim();
                    qbSearchTerm = qbSearchTerm.replace('&', encodeURIComponent('&'));
                    if (qbSearchTerm !== '') {
                        //qbObject[qbSearchTypeFieldName] = qbSearchTerm;
                        qbObject[keyDefName] = qbSearchTerm;
                        qbObjectInitialized = true;
                    }
                    break;
            }
        }
        instanceIndex++;
    });

    //remove pagination if exists
    var page = SCM.Common.getQueryStringValue(currentDataUrl, 'page');

    if (currentDataUrl === 'page=1') {
        currentDataUrl = '&page=1';
    }
    if (page !== null && page !== '') {
        currentDataUrl = currentDataUrl.replace('page=' + page + '&', 'page=1&');
    }

    redirectUrl = currentDataUrl;

    if (qbObjectInitialized) {
        var qbObjectParms = JSON.stringify(qbObject);
        qbObjectParms = qbObjectParms.indexOf('&') !== -1 ? encodeURIComponent(qbObjectParms) : qbObjectParms;
        var oldQb = SCM.Common.getQueryStringValue(currentDataUrl, 'qb');
        if (oldQb) {
            redirectUrl = redirectUrl.replace(oldQb, qbObjectParms);
        }
        else {
            var lastChar = redirectUrl[redirectUrl.length - 1];
            var qbQueryStringKey = lastChar === '&' ? 'qb=' : '&qb=';
            redirectUrl = redirectUrl + qbQueryStringKey + qbObjectParms;
        }
    }

    SCM.QueryBuilder.defaults.runSearch(redirectUrl);
});

function getQueryStringSearchParams(pairs) {
    const params = {};
    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split('=');
        const key = decodeURIComponent(pair[0]);
        const value = pair.length > 1 ? decodeURIComponent(pair[1]) : '';

        if (params.hasOwnProperty(key)) {
            params[key] = [].concat(params[key], value);
        } else {
            params[key] = value;
        }
    }

    return params;
}

function getUpdatedDateUrl(params, currentDataUrl, searchTerm) {
    if ('q' in params) {
        let qValue = params['q'];
        if (qValue !== null && qValue !== '') {
            params['q'] = searchTerm;

            const keyValuePairs = [];
            for (let key in params) {
                if (params.hasOwnProperty(key)) {
                    const value = params[key];
                    keyValuePairs.push(key + '=' + value);
                }
            }
            currentDataUrl = keyValuePairs.join('&');
        } else {
            currentDataUrl = 'q=' + searchTerm + '&' + currentDataUrl;
        }
    } else {
        currentDataUrl = 'q=' + searchTerm + '&' + currentDataUrl;
    }

    return currentDataUrl;
}

//KeyUp event for Query Builder input button
$('.js-querybuilder-input').keyup(function (e) {
    var key = e.which; // recommended to use e.which, it's normalized across browsers
    if (key === 13) e.preventDefault();
    var inputVal = $.trim($(this).val());
    if (key === 13 && inputVal !== '') // the enter key code
    {
        $('.querybuilder-submit').click();
        return false;
    }
});

//NARN-3759 - .startsWith is not supported by IE - Polyfill - BENC - 9/15/2016
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

//NARN-3759 - .endsWith is not supported by IE - Polyfill - BENC - 9/15/2016
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.lastIndexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

